import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TValueListItem {
  id: number;
  code: string;
  label: string;
  value: string;
}

export interface IValueListItem extends TValueListItem {}

const ValueListItem = Model(
  (model: TValueListItem): IValueListItem => {
    const _valueListItem: TValueListItem = Object.assign({}, model);

    let create = (valueListItem: IValueListItem): IValueListItem => {
      let obj = ValidatableObject(valueListItem);
      return obj;
    };

    let valueListItem = {
      get id() {
        return _valueListItem.id;
      },
      get code() {
        return _valueListItem.code;
      },
      get label() {
        return _valueListItem.label;
      },
      get value() {
        return _valueListItem.value;
      }
    };

    return create(valueListItem);
  }
);

export default ValueListItem;
